export default __webpack_public_path__ + "static/media/main-bar-group.e8b9ad52.png";